import { CaretRight } from '@phosphor-icons/react';
import * as Collapsible from '@radix-ui/react-collapsible';
import { Text } from '@typedream/ui';
import classNames from 'classnames';
import { useState } from 'react';
import { MenuCollapsibleProps } from './types';

export function MenuCollapsible({
  heading,
  defaultOpen = false,
  suffix,
  children,
}: MenuCollapsibleProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Collapsible.Root
      open={isOpen}
      onOpenChange={setIsOpen}
      defaultOpen={defaultOpen}
      className="flex flex-col gap-1"
    >
      <div className="flex gap-1.5 text-secondary items-center">
        <Collapsible.Trigger className="flex flex-1 gap-1.5 p-1.5 items-center w-full border-0 bg-transparent text-secondary cursor-pointer">
          <Text size="xs" weight="medium" variant="secondary">
            {heading}
          </Text>
          <CaretRight
            size={16}
            weight="bold"
            className={classNames('transition-all ease-out duration-200', { 'rotate-90': isOpen })}
          />
        </Collapsible.Trigger>
        {suffix}
      </div>
      <Collapsible.Content>
        <>{children}</>
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
